import React from 'react';
import './BreakdownGraph.css';
import { Line } from 'react-chartjs-2';
import { penceToPounds } from '../../utils/currency'
import moment from 'moment'

const BreakdownGraph = ({ children, history, hasPrevious, handlePreviousClick, hasNext, handleNextClick, currentDay, currentMonth, currentYear }) => {

  if (history.length === 0) {
    return null
  }

  const mockOptions = {
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
        }
      }]
    }
  }

  const months = history.map((day) => {
    return `${day.day}/${day.month}/${day.year}`
  });

  const totalNetWorth = history.map((day) => {
    return day.balance / 100;
  });

  const totalAssets = history.map((day) => {
    return day.assets.reduce((total, group) => {
      return total + (group.balance / 100);
    }, 0);
  });

  const totalLiabilities = history.map((day) => {
    return day.liabilities.reduce((total, group) => {
      return total + (group.balance / 100);
    }, 0) * -1;
  });

  const mockData = {
    labels: months, // months
    datasets: [{
      label: 'Total Net Worth',
      data: totalNetWorth, // totals and tool tips
      backgroundColor: ['rgba(64, 187, 157, 0.2)'],
      borderColor: ['rgba(64, 187, 157, 1)'],
      borderWidth: 1,
    }, {
      label: 'Total Assets',
      data: totalAssets, // totals and tool tips
      backgroundColor: ['purple'],
      borderColor: ['rgba(64, 187, 157, 1)'],
      borderWidth: 1,
      hidden: true,
    },
    {
      label: 'Total Liabilities',
      data: totalLiabilities, // totals and tool tips
      backgroundColor: ['red'],
      borderColor: ['rgba(64, 187, 157, 1)'],
      borderWidth: 1,
      hidden: true,
    }]
  }

  // if (history.length === 1) {
  //   return (
  //     <div className="container">
  //     <p className="alert alert-info">
  //       To show a graph of your net worth over time, you need to add a new month of data.
  //       You can do this by clicking the <strong className="text-success">"Add Month"</strong> button in the top right.
  //     </p>
  //     </div>
  //   )
  // }

  const fmtDate = moment({
    year: currentYear,
    month: currentMonth - 1,
    day: currentDay,
  }).format('LL');

  return (
    <section className="breakdown-graph">
      <div className="container">
        <div className="breakdown-graph__inner">
          {history.length > 1 && (
            <Line
              data={mockData}
              options={mockOptions}
              width="600"
              height="200"
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default BreakdownGraph


// {history.length > 1 && history.map((day) => {
//   return <div>{`${day.day}/${day.month}/${day.year}`}</div>
// })}



// WEBPACK FOOTER //
// ./src/components/BreakdownGraph/BreakdownGraph.js